<template>
  <TableLayout>
    <template v-slot:table-wrap>
      <!-- 搜索区域 -->
      <ul class="search-box">
        <li>
          <h4>系统名称</h4>
          <el-input placeholder="请输入系统名称" v-model="form.systemName" @keyup.enter.native="fetchModules">
            <el-button slot="append" :loading="isWorking.aiButton" :disabled="isWorking.aiButton" @click="fetchModules">AI获取</el-button>
          </el-input>
        </li>
        <li>
          <h4>所属行业</h4>
          <IndustrySelect
            v-model="form.industryId"
            placeholder="请选择所属行业"
            clearable
            filterable
          />
        </li>
      </ul>
      <div class="operate">
        <el-button type="primary" @click="confirm" :disabled="isWorking.confirmButton" :style="{width: isWorking.confirmButton ? '250px' : '150px'}">
          {{isWorking.confirmButton ? '正在录入，请勿关闭页面' : '确认录入'}}
        </el-button>
      </div>
      <!-- 列表区域 -->
      <div class="list-box">
        <NavMenu
          ref="navMenu"
          :modules="moduleData.list"
          :current-module="moduleData.current"
          @delete="deleteModule"
          @reload="fetchFields"
          @edit="editModule"
          @creation="creationModule"
          @select="moduleData.current = $event"
          @load-fields="fetchAllModuleFields"
        />
        <div class="table-wrap">
          <h4>字段配置</h4>
          <template v-if="moduleData.current != null">
            <template v-if="moduleData.current.__failed || !hasModuleField || hasEmptyVariable || hasEmptyLabel || hasRepeatVariable || hasRepeatLabel || hasFieldWithoutRows">
              <el-alert v-if="moduleData.current.__failed" title="模块字段信息加载失败" type="error" show-icon :closable="false"></el-alert>
              <el-alert v-if="hasEmptyVariable" title="请勿存在空的字段英文名称" type="error" show-icon :closable="false"></el-alert>
              <el-alert v-if="hasEmptyLabel" title="请勿存在空的字段中文名称" type="error" show-icon :closable="false"></el-alert>
              <el-alert v-if="hasRepeatVariable" title="请勿存在重复的字段英文名称" type="error" show-icon :closable="false"></el-alert>
              <el-alert v-if="hasRepeatLabel" title="请勿存在重复的字段中文名称" type="error" show-icon :closable="false"></el-alert>
              <el-alert v-if="hasFieldWithoutRows" title="存在字段没有模拟数据，请检查模拟数据为红色的字段" type="error" show-icon :closable="false"></el-alert>
              <el-alert v-if="!hasModuleField" title="该模块没有字段信息，请加载模块字段" type="error" show-icon :closable="false"></el-alert>
            </template>
            <template v-else>
              <el-alert v-if="hasInvalidVariable" title="存在不合规的字段英文名称，英文名称必须大于2个字符，且必须为小写字母，特殊字符仅允许使用'_'，且不能以'_'和数字开头或结尾" type="error" show-icon :closable="false"></el-alert>
              <el-alert v-if="!hasNumberField" title="模块中没有数字字段，展现形式将不会支持折线图和柱状图" type="warning" show-icon :closable="false"></el-alert>
              <el-alert v-if="!hasImageField" title="模块中没有图片字段，展现形式将不会支持卡片列表、大图列表和垂直列表" type="warning" show-icon :closable="false"></el-alert>
              <el-alert v-if="hasFieldRowsNotMatched" title="模块中存在字段模拟数据可能出现不匹配的情况，请检查模拟数据为黄色的字段" type="warning" show-icon :closable="false"></el-alert>
            </template>
          </template>
          <div class="table-padding">
            <!-- style="background-color: #fff; padding: 10px" -->
            <div class="table-operation" v-if="moduleData.current != null">
              <el-button type="primary" icon="el-icon-plus" @click="createEmptyField">新建</el-button>
              <el-button icon="el-icon-delete" @click="deleteFieldsInBatch">删除</el-button>
            </div>
            <el-table
              v-if="moduleData.current != null"
              :data="moduleData.current.fields"
              stripe
              @selection-change="handleFieldsSelectionChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
<!--              <el-table-column prop="fieldType" label="字段类型" min-width="170px">-->
<!--                <FieldTypeSelect-->
<!--                  slot-scope="{row}"-->
<!--                  placeholder="请选择字段类型"-->
<!--                  v-model="row.fieldType"-->
<!--                  :clearable="true"-->
<!--                  @change="fillRowByType(row, $event)"-->
<!--                />-->
<!--              </el-table-column>-->
              <el-table-column prop="dataType" label="字段数据类型" min-width="100px">
                <template slot-scope="{ row }">
                  <el-select v-model="row.dataType" @change="handleDataTypeChange(row)"  placeholder="请选择字段类型">
                    <el-option value="TEXT" label="文本"/>
                    <el-option value="IMAGE" label="图片"/>
                    <el-option value="NUMBER" label="数字"/>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="variable" label="字段英文名称" min-width="170px">
                <template slot-scope="{ row, $index }">
                  <el-input v-model="row.variable" placeholder="请输入字段英文名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="label" label="字段中文名称" min-width="170px">
                <template slot-scope="{ row, $index }">
                  <el-input v-model="row.label" placeholder="请输入字段中文名称"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="rows" label="模拟数据" min-width="170px">
                <template slot-scope="{ row }">
                  <span :style="{color: row.rows.length === 0 && row.fieldType.length === 0 ? 'red' : (!row.label.startsWith('是否') && row.rows.length !== 5 && row.fieldType.length === 0 ? 'orange' : '')}">{{row.rows.length}}</span>
                  <span>条</span>
                </template>
              </el-table-column>
              <el-table-column prop="isQueryField" label="搜索条件" min-width="100px">
                <template slot-scope="{ row }">
                  <el-checkbox v-model="row.isQueryField" :disabled="row.dataType === 'IMAGE' "></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="isCreateField" label="新建&编辑字段" min-width="120px">
                <template slot-scope="{ row }">
                  <el-checkbox v-model="row.isCreateField"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="required" label="新建&编辑是否必填" min-width="140px">
                <template slot-scope="{ row }">
                  <el-checkbox v-model="row.required"></el-checkbox>
                </template>
              </el-table-column>
<!--              <el-table-column prop="fixed" label="是否固定" min-width="140px">-->
<!--                <template slot-scope="{ row }">-->
<!--                  <el-checkbox v-model="row.fixed"></el-checkbox>-->
<!--                </template>-->
<!--              </el-table-column>-->
              <el-table-column
                label="操作"
                min-width="200"
                fixed="right"
              >
                <template slot-scope="{ row, $index }">
                  <el-button
                    type="text"
                    :disabled="row.fieldType.length > 0 || row.dataType === 'IMAGE' || row.label.trim() === '' || row.variable.trim() === '' || row.__loading"
                    @click="fetchFieldRows(moduleData.current, row, 0)"
                  >
                    {{ row.__loading ? '加载中...' : '加载数据' }}
                  </el-button>
                  <el-button
                    type="text"
                    :disabled="row.fieldType.length > 0 || row.label.trim() === '' || row.variable.trim() === ''"
                    @click="$refs.fieldDataTableWindow.open(row)"
                  >
                    字段数据
                  </el-button>
                  <el-button type="text" @click="deleteField($index)" icon="el-icon-delete">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="empty-tip">
              <div class="empty-wrap">
                <p>暂无字段可配置</p>
                <p>1. 点击左侧模块</p>
                <p>2. 智能加载模块字段信息</p>
                <p>3. 完成字段配置</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="operate">
        <el-button type="primary" @click="confirm" :disabled="isWorking.confirmButton" :style="{width: isWorking.confirmButton ? '250px' : '150px'}">
          {{isWorking.confirmButton ? '正在录入，请勿关闭页面' : '确认录入'}}
        </el-button>
      </div>
    </template>
    <FieldDataTableWindow ref="fieldDataTableWindow" @save="saveToStorage"/>
  </TableLayout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TableLayout from '@/layouts/TableLayout'
import NavMenu from '@/components/ai/NavMenu'
import IndustrySelect from '@/components/runner/IndustrySelect'
import FieldDataTableWindow from '@/components/ai/FieldDataTableWindow'
import ModuleFieldMixin from '@/components/ai/ModuleFieldMixin'
import ValidateMixin from '@/components/ai/ValidateMixin'
import FieldTypeSelect from '@/components/common/FieldTypeSelect'
import { modules, fields, inputSystem } from '@/api/ai/index'
export default {
  mixins: [ModuleFieldMixin, ValidateMixin],
  components: { FieldTypeSelect, FieldDataTableWindow, IndustrySelect, NavMenu, TableLayout },
  data () {
    return {
      // 是否正在处理中
      isWorking: {
        aiButton: false,
        confirmButton: false
      },
      // 表单
      form: {
        systemName: '',
        industryId: null
      },
      // 模块相关
      moduleData: {
        // 模块列表
        list: [
          // {
          //   moduleName: '客户管理',
          //   fields: [
          //     {
          //       dataType: 'TEXT',
          //       variable: 'name',
          //       label: '客户名称',
          //       isQueryField: true,
          //       isCreateField: true,
          //       required: true,
          //       rows: [],
          //       __loading: false
          //     }
          //   ],
          //   __loading: false,
          //   __failed: true
          // }
        ],
        // 当前模块
        current: null
      }
    }
  },
  computed: {
    ...mapState(['fieldTypeData']),
    storage () {
      return [this.moduleData.list]
    }
  },
  watch: {
    storage () {
      this.saveToStorage()
    }
  },
  methods: {
    ...mapActions(['initParseModuleFunction', 'initParseFieldFunction', 'initParseFieldRowsFunction', 'initFieldTypes']),
    // 存储到本地
    saveToStorage () {
      localStorage.setItem('AI_FORM', JSON.stringify(this.form))
      localStorage.setItem('AI_DATA', JSON.stringify(this.moduleData.list))
    },
    // 根据类型填充行
    fillRowByType (row, type) {
      row.dataType = type.type
      row.variable = row.variable === '' ? type.variable : row.variable
      row.label = row.label === '' ? type.label : row.label
      row.rows = []
    },
    // 加载所有模块字段
    fetchAllModuleFields () {
      const loading = this.moduleData.list.find(item => item.__loading) != null
      if (loading) {
        return
      }
      // 判断是否已经加载过
      const isLoaded = this.moduleData.list.find(item => item.fields.length > 0) != null
      if (!isLoaded) {
        for (const module of this.moduleData.list) {
          this.fetchFields(module, 0)
        }
        return
      }
      // 已经加载过，二次提醒是否确认全部重新加载
      this.$dialog.confirm('该操作将重新加载所有模块的字段列表，确认执行吗？', '提示', {
        confirmButtonText: '重新加载',
        type: 'warning'
      })
        .then(() => {
          for (const module of this.moduleData.list) {
            this.fetchFields(module, 0)
          }
        })
        .catch(() => {})
    },
    // 删除模块
    deleteModule (module, index) {
      this.$dialog.deleteConfirm(`确认删除【${module.moduleName}】模块吗？`)
        .then(() => {
          this.moduleData.list.splice(index, 1)
          // 删除的是当前选中的模块
          if (this.moduleData.current === module) {
            this.moduleData.current = null
          }
        })
        .catch(() => {})
    },
    // 编辑模块
    editModule (item) {
      this.$prompt('请输入模块名称', '编辑模块', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: `${item.moduleName}`,
        inputValidator: (value) => {
          if (!value.trim()) return '输入不能为空'
        },
        closeOnClickModal: false
      }).then(({ value }) => {
        item.moduleName = value.trim()
        this.fetchFields(item)
        this.$tip.success('编辑成功')
      })
    },
    // 创建模块
    creationModule () {
      this.$prompt('请输入模块名称', '创建模块', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // inputValue: `${item.moduleName}`,
        inputValidator: (value) => {
          if (!value.trim()) return '输入不能为空'
        },
        closeOnClickModal: false
      }).then(({ value }) => {
        const item = window.parseModules('||' + value.trim())[0]
        this.$set(item, '__loading', false)
        this.$set(item, '__failed', false)
        this.$set(item, 'fields', [])
        this.moduleData.list.push(item)
        this.fetchFields(item)
        this.$tip.success('创建成功')
      })
    },
    // 处理模块数据接口
    fetchModules (count = 0) {
      if (this.isWorking.aiButton) {
        return
      }
      if (this.form.systemName.trim() === '') {
        this.$tip.warning('请输入系统名称')
        return
      }
      this.isWorking.aiButton = true
      modules({
        systemName: this.form.systemName.trim()
      })
        .then(data => {
          this.moduleData.list = window.parseModules(data.answer)
          if (this.moduleData.list == null) {
            this.moduleData.list = []
          }
          this.form.industryId = data.industryId
          for (const item of this.moduleData.list) {
            this.$set(item, '__loading', false)
            this.$set(item, '__failed', false)
            this.$set(item, 'fields', [])
          }
        })
        .catch(e => {
          // 模块接口调用失败后继续调用，5次都没成功时提示报错
          if (count < 5) {
            this.isWorking.aiButton = false
            this.$nextTick(() => {
              count++
              this.fetchModules(value, count)
            })
            return
          }
          this.$tip.apiFailed(e) // 模块接口失败5次后再提示
        })
        .finally(() => {
          this.isWorking.aiButton = false
        })
    },
    // 处理字段数据接口
    fetchFields (module, count) {
      if (module.__loading) {
        return
      }
      module.fields = []
      module.__loading = true
      module.__failed = false
      fields({
        zhName: module.moduleName,
        systemName: this.form.systemName
      })
        .then(data => {
          module.fields = window.parseFields(data)
          if (module.fields == null) {
            module.fields = []
          }
          for (const item of module.fields) {
            this.$set(item, 'rows', [])
            this.$set(item, 'isQueryField', true)
            this.$set(item, 'isCreateField', true)
            this.$set(item, 'fixed', true)
            this.$set(item, 'required', true)
            // 自动获取匹配的字段类型
            // const targetFieldType = this.getFieldTypeByField(item)
            const fieldTypeValue = []
            // if (targetFieldType != null) {
            //   fieldTypeValue.push(targetFieldType.type.value)
            //   if (targetFieldType.subType != null) {
            //     fieldTypeValue.push(targetFieldType.subType.variable)
            //   }
            // }
            this.$set(item, 'fieldType', fieldTypeValue)
            this.$set(item, '__loading', false)
            // 如果存在匹配的已有字段类型，则覆盖变量
            // if (targetFieldType != null) {
            //   const type = targetFieldType.subType == null ? targetFieldType.type : targetFieldType.subType
            //   item.variable = type.variable
            //   item.label = type.label
            //   item.dataType = type.type
            // }
            // 如果不存在匹配的已有字段类型，则自动加载字段模拟数据
            // if (targetFieldType == null) {
            setTimeout(() => {
              this.fetchFieldRows(module, item, 0)
            }, 0)
            // }
            // 添加随机字母
            item.variable = item.variable.toLowerCase()
            item.variable = this.generateRandomLetters(4) + '_' + item.variable + '_' + this.generateRandomLetters(4)
          }
          this.saveToStorage()
        })
        .catch(e => {
          if (count < 5) {
            this.fetchFields(module, ++count)
            return
          }
          module.__failed = true
          this.$tip.apiFailed(e)
        })
        .finally(() => {
          module.__loading = false
        })
    },
    // 录入
    confirm () {
      if (this.isWorking.confirmButton) {
        return
      }
      this.validateConfirmInput()
        .then(warningMessage => {
          this.$dialog.confirm(warningMessage == null ? '确认录入吗？' : (warningMessage + '，确认录入吗？'), '提示', {
            confirmButtonText: '立即录入',
            type: warningMessage == null ? 'info' : 'warning'
          })
            .then(() => {
              this.isWorking.confirmButton = true
              inputSystem({
                industryId: this.form.industryId,
                modules: this.moduleData.list.map((item) => {
                  return {
                    description: '',
                    enName: item.moduleEnName,
                    fixed: false,
                    name: item.moduleName,
                    fields: item.fields.map(field => {
                      return {
                        ...field,
                        fieldType: JSON.stringify(field.fieldType)
                      }
                    })
                  }
                })
              })
                .then(data => {
                  const systemName = this.form.systemName.trim()
                  // 清理数据
                  localStorage.removeItem('AI_FORM')
                  localStorage.removeItem('AI_DATA')
                  this.moduleData.list = []
                  this.moduleData.current = null
                  this.form.systemName = ''
                  this.form.industryId = null
                  this.$dialog.alert('模块和字段配置以及字段数据全部录入成功！数据缓存已被清理', '提示', {
                    confirmButtonText: 'OK'
                  })
                    .then(() => {
                      // 跳转到生成代码页面
                      this.$router.push({
                        path: '/generator',
                        query: {
                          name: systemName,
                          logo_file_key: this.$route.query.logo_file_key,
                          industryId: data.industryId,
                          moduleIds: data.moduleIds.join(',')
                        }
                      })
                    })
                })
                .catch(e => {
                  this.$tip.apiFailed(e)
                })
                .finally(() => {
                  this.isWorking.confirmButton = false
                })
            })
            .catch(() => {})
        })
        .catch(message => {
          this.$tip.error(message)
          this.isWorking.confirmButton = false
        })
    },
    // 根据字段获取字段类型
    getFieldTypeByField (field) {
      for (const fieldType of this.fieldTypeData.list) {
        // 对象类型
        if (fieldType.type === 'OBJECT') {
          for (const subType of fieldType.children) {
            if (subType.label === field.label) {
              return { type: fieldType, subType }
            }
          }
          continue
        }
        // 非对象类型
        if (fieldType.label === field.label) {
          return { type: fieldType }
        }
      }
      return null
    },
    // 初始化参数
    initParams () {
      if (this.$route.query.project_name != null && this.$route.query.project_name !== '') {
        this.form.systemName = this.$route.query.project_name.trim()
      }
    },
    // 生成随机字母
    generateRandomLetters (length) {
      let result = ''
      const characters = 'abcdefghijklmnopqrstuvwxyz'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    }
  },
  created () {
    // 读取缓存数据
    const aiData = localStorage.getItem('AI_DATA')
    const aiForm = localStorage.getItem('AI_FORM')
    if (aiData != null && aiData !== '') {
      try {
        this.moduleData.list = JSON.parse(aiData)
        this.moduleData.list = this.moduleData.list.map(module => {
          return {
            ...module,
            __loading: false,
            __failed: false,
            fields: module.fields.map(field => {
              return {
                ...field,
                __loading: false
              }
            })
          }
        })
      } catch (e) {
      }
    }
    if (aiForm != null && aiForm !== '') {
      try {
        this.form = JSON.parse(aiForm)
      } catch (e) {
      }
    }
    // 初始化路由参数
    this.initParams()
    // 初始化脚本
    this.initParseModuleFunction()
    this.initParseFieldFunction()
    this.initParseFieldRowsFunction()
    // 初始化字段类型，用于字段获取字段对应的字段类型
    this.initFieldTypes()
  }
}
</script>

<style scoped lang="scss">
// 搜索区
.search-box {
  display: flex;
  flex-wrap: wrap;
  padding: 0 16px 16px 16px;
  li {
    margin-right: 20px;
    margin-bottom: 10px;
    position: relative;
    h4 {
      margin-bottom: 10px;
      font-size: 13px;
      font-weight: 400;
      color: #666;
    }
    /deep/ .el-input {
      input {
        width: 600px;
        height: 45px;
        border-radius: 22px;
        font-size: 15px;
      }
      .el-input-group__append {
        width: 155px;
        top: 0;
        right: 0;
        border: 0;
        display: flex;
        justify-content: center;
        position: absolute;
        height: 45px;
        background-color: #2782e0;
        overflow: hidden;
        border-radius: 22px;
        padding: 0;
        &:hover {
          background-color: #2376cb;
        }
        button {
          width: 100%;
          background-color: initial;
          color: #fff;
          font-size: 16px;
          border: 0;
        }
      }
    }
    /deep/.el-input.el-input--small.el-input--suffix {
      input {
        width: 250px;
      }
    }
    span {
      color: #f56c6c;
      font-size: 14px;
      position: absolute;
      left: 10px;
      bottom: -20px;
    }
  }
}
// 菜单区
/deep/ .list-box {
  display: flex;
  border-radius: 10px;
  overflow: hidden;
  height: 60vh;
  padding: 3px 2px;
  background: #f0f0f0;
  .table-wrap {
    height: 100%;
    flex-grow: 1;
    width: 56vh;
    background: #f0f0f0;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    h4 {
      padding: 5px 10px;
      font-size: 15px;
      font-weight: normal;
      flex-shrink: 0;
      border-bottom: 1px solid #e0e0e0;
    }
    .table-padding {
      padding: 10px;
      flex-grow: 1;
      background: #343434;
      overflow-y: auto;
      .el-table {
        min-height: 100%;
      }
      .empty-tip {
        height: 100%;
        font-size: 13px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #f7f7f7;
        .empty-wrap {
          width: 150px;
          margin-top: -100px;
          p {
            margin: 0;
            &:first-of-type {
              color: #999;
              text-align: center;
              margin-bottom: 10px;
            }
          }
        }
      }
      .table-operation {
        background-color: #fff;
        padding: 10px;
        border-bottom: 1px solid #eee;
      }
    }
    .is-light {
      margin-bottom: 5px;
      /*padding: 4px 8px !important;*/
    }
  }
}
.operate {
  display: flex;
  justify-content: center;
  padding: 15px 0;
  .el-button {
    width: 100% !important;
    height: 50px;
    border-radius: 10px;
    font-size: 15px;
  }
  button {
    background-color: #2782e0;
    color: #fff;
  }
}
</style>
